import { render } from "./ShopUnavailable.vue?vue&type=template&id=50c86154"
import script from "./ShopUnavailable.vue?vue&type=script&lang=js"
export * from "./ShopUnavailable.vue?vue&type=script&lang=js"

import "./ShopUnavailable.vue?vue&type=style&index=0&id=50c86154&lang=scss"
script.render = render

export default script